<template>
  <input
    type="text"
    :class="styleInput"
    :value="value"
    @keydown="checkNumberKey"
    @input="checkNumberInput"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    cclass: {
      type: Boolean,
      default: false,
    },
    override: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    styleInput() {
      if (this.cclass) {
        return "inputerror";
      } else {
        return "";
      }
    },
  },
  methods: {
    checkNumberKey(evt) {
      if (!this.override) {
        evt = evt ? evt : window.event;

        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
          charCode > 31 &&
          (charCode < 37 || charCode > 40) &&
          (charCode < 48 || (charCode > 57 && charCode < 95) || charCode > 105)
        ) {
          evt.preventDefault();
        }
      }
      return true;
    },
    checkNumberInput(evt) {
      if (!this.override) {
        evt.target.value = evt.target.value.replace(/[^0-9]+/g, "");
      }
      this.$emit("input", evt.target.value);
    },
  },
};
</script>
